import {
  Button,
  Image,
  Stack,
  Strong,
  Text,
  VStack,
  Input,
  HStack,
  Link,
  Box,
} from "@chakra-ui/react";
import React, { useEffect, useState, useRef } from "react";
import logo from "../../Images/logo.png";
import { useDispatch, useSelector } from "react-redux";
import { verifyEmail } from "../../Redux/Action/auth/verifyEmailAction";
import { useNavigate } from "react-router-dom";
import { Field } from "../ui/field";
import { PasswordInput } from "../ui/password-input";
import { getLocalStorageItem } from "../../Utils/Helper";
import { useTheme } from "next-themes";
import { OtpInput } from "./OtpInput";
import { CommonButton } from "../ui/CommonButton";
import {UPDATE_PASSOWRD_PARAMS} from "../../Utils/Constants"
export const ForgotPasswordForm = () => {
  const [email, setEmail] = useState("");
  const [passwords, setPasswords] = useState({ password: "", cpassword: "" });
  const [uid, setUid] = useState("");
  const [OTP, setOTP] = useState("");
  const [step, setStep] = useState("step1");
  const [isTimerOn, setIsTimerOn] = useState(false);
  const [isRed, setIsRed] = useState(false);
  const [isInputDisabled, setIsInputDisabled] = useState(true);
  const [timeLeft, setTimeLeft] = useState(0);
  const [isEnteringCP, setIsEnteringCP] = useState(false);
  const [passwordMissmatched, setPasswordMisssmatched] = useState(false);
  const timerRef = useRef(null);
 const whitelabelData = getLocalStorageItem("whitelabelData");
  const dispatch = useDispatch();
  const { resolvedTheme } = useTheme();
  const navigate = useNavigate();
    const loading = useSelector((state) => state?.GetWhitelabel?.loading);
  const [logoSrc, setLogoSrc] = useState(null);

  
    useEffect(() => {
    if (!loading) {
      const selectedLogo =
        whitelabelData && resolvedTheme === "dark"
          ? whitelabelData.logo_dark
          : whitelabelData?.logo_light;

      setLogoSrc(selectedLogo || logo);
    }
  }, [loading, resolvedTheme]);
  const handleSendOTP = () => {
    setOTP("");
    setIsInputDisabled(false);
    setIsTimerOn(true);
    setTimeLeft(120);
    let forgotParam = UPDATE_PASSOWRD_PARAMS
    const payload = {
      type: "requestOTP",
      email,
      forgotParam
    };
    dispatch(
      verifyEmail({
        payload,
        route: "FP",
        callback: (data) => {
          if (data?.meta?.code !== 200) {
            setIsTimerOn(false);
            setIsInputDisabled(true);
            clearInterval(timerRef.current);
          }
        },
      })
    );

    if (timerRef.current) {
      clearInterval(timerRef.current);
    }

    timerRef.current = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timerRef.current);
          setIsTimerOn(false);
          setIsInputDisabled(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const handleSubmit = () => {
    if (OTP.length === 6) {
      setIsInputDisabled(true);
      const payload = {
        type: "submitOTP",
        email,
        OTP: OTP,
      };
      dispatch(
        verifyEmail({
          payload,
          route: "FP",
          callback: (data) => {
            if (data?.meta?.code === 200) {
              setStep("step2");
              setUid(data?.data);
              clearInterval(timerRef.current);
            } else {
              setIsInputDisabled(false);
            }
          },
        })
      );
    }
  };

  const handleChangePasswordSubmit = () => {
    const passwordRegex = /^(?=.*[A-Z])(?=.*[@#]).{8,}$/;
    if (passwordRegex.test(passwords?.password)) {
      const payload = {
        type: "changePassword",
        email,
        password: passwords?.password,
        uid,
      };
      dispatch(
        verifyEmail({
          payload,
          route: "FP",
          callback: (data) => {
            if (data?.meta?.code === 200) {
              navigate("/login");
            } else {
              setIsInputDisabled(false);
            }
          },
        })
      );
    } else {
      setIsRed(true);
    }
  };

  const handleChange = (e) => {
    setIsRed(false);
    const { name, value } = e?.target || {};

    setPasswords((prev) => {
      const updatedForm = { ...prev, [name]: value };
      if (name === "password" || name === "cpassword") {
        setPasswordMisssmatched(updatedForm.password !== updatedForm.cpassword);
      }

      return updatedForm;
    });
  };

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s < 10 ? "0" + s : s}`;
  };

  useEffect(() => {
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []);

  return (
    <Stack
      gap="6"
      align="center"
      maxW="md"
      width="100%"
      margin="auto"
      borderRadius="xl"
      padding={{ base: "1.5rem", sm: "2rem", md: "3rem" }}
      boxShadow={
        resolvedTheme === "dark"
          ? "var(--themeColor) 0px 4px 12px 0px"
          : "rgba(99, 99, 99, 0.2) 0px 4px 12px 0px"
      }
      bg={resolvedTheme === "dark" ? "gray.800" : "white"}
    >
      <Image 
        src={logoSrc} 
        alt="Logo" 
        maxW="120px" 
        mb={2} 
        objectFit="contain"
      />
      {step === "step1" ? (
        <>
          <Field label="Enter your Email:" width="100%">
            <Input
              name="email"
              value={email}
              disabled={isTimerOn}
              onChange={(e) => setEmail(e?.target?.value)}
              padding={3}
              borderRadius="md"
              borderWidth="1px"
            />
          </Field>
          <Field label="Enter OTP received on your email:" width="100%">
            <OtpInput 
              value={OTP} 
              onChange={setOTP} 
              isDisabled={isInputDisabled}
            />
          </Field>

          <Box minH="1.5rem" textAlign="center" width="100%">
            {isTimerOn ? (
              <Text fontSize="sm" color="gray.500">
                Not received yet! You can resend it in{" "}
                <Text as="span" color="blue.500" fontWeight="medium" fontSize="md">
                  {formatTime(timeLeft)}
                </Text>
              </Text>
            ) : (
              <Text>&nbsp;</Text>
            )}
          </Box>

          <CommonButton
            text={isTimerOn ? "Re-Send OTP" : "Send OTP"}
            onClick={handleSendOTP}
            disabled={isTimerOn}
            width="100%"
            variant={isTimerOn ? 'default' : 'gradient'}
          />

          <CommonButton
            text="Submit"
            onClick={handleSubmit}
            disabled={OTP.length !== 6 || isInputDisabled}
            width="100%"
            variant={OTP.length === 6 && !isInputDisabled ? 'gradient' : 'default'}
          />
        </>
      ) : (
        <VStack width="100%" spacing={5}>
          <Field label="Password" width="100%">
            <PasswordInput
              name="password"
              value={passwords?.password}
              onChange={handleChange}
              padding={3}
              borderRadius="md"
              borderWidth="1px"
            />
          </Field>
          <Field
            label="Confirm Password"
            width="100%"
            color={
              isEnteringCP
                ? passwordMissmatched
                  ? "red.500"
                  : "green.500"
                : ""
            }
          >
            <PasswordInput
              name="cpassword"
              value={passwords?.cpassword}
              onFocus={() => setIsEnteringCP(true)}
              onBlur={() => setIsEnteringCP(false)}
              onChange={handleChange}
              padding={3}
              borderRadius="md"
              borderWidth="1px"
            />
          </Field>
          <Text
            fontSize="sm"
            color={isRed ? "red.500" : "gray.600"}
            animation="pulse 2s infinite"
            textAlign="center"
            px={2}
          >
            Password must be at least 8 characters, with one uppercase and
            either '@' or '#'.
          </Text>
          <CommonButton
            text="Submit"
            onClick={handleChangePasswordSubmit}
            disabled={passwordMissmatched || !passwords?.password || !passwords?.cpassword}
            width="100%"
            variant={passwordMissmatched || !passwords?.password || !passwords?.cpassword ? 'default' : 'gradient'}
          />
        </VStack>
      )}
      <HStack fontSize="md">
        <Link color="blue.500" onClick={() => navigate("/login")}>
          Back to Login
        </Link>
      </HStack>
    </Stack>
  );
};